import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
	PRODUCTS,
	PRODUCT_GROUPS,
	PRODUCT_ADD,
	PRODUCT_DELETE,
	GET_PRODUCT_ROW_DATA,
} from "./actionTypes";
import {
	apiError,
	getProducts,
	productListSuccessful,
	productAddSuccessful,
	product_row_successfull,
	productgroupListSuccessful,
} from "./actions";
import {
	ProductActivateuccessful,
	cProducthideRightSidebar,
} from "../../../store/MaterialRequest/actions";

import {
	postAdd,
	putImg,
	getList,
	getParamsList,
	postEdit,
	postDelete,
} from "../../../helpers/Helper";
import swal from "sweetalert";

import { changeSidebarType as changeSidebarTypeAction } from "../../layout/actions";

function* getProductGroups() {
	try {
		const response = yield call(
			getList,
			"/masters/higherentry/pgroups/",
			{}
		);

		yield put(productgroupListSuccessful({ response }));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getProduct({ payload: { data } }) {
	var params = {};

	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "currentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.currentSort;
			} else {
				if (data[k] !== "") {
					params[k] = data[k];
				}
			}
		}
	}
	try {
		const response = yield call(
			getParamsList,
			"/masters/products/",
			params
		);

		yield put(productListSuccessful({ response }));
		yield put(changeSidebarTypeAction("icon"));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* GetProductRowData(proId) {
	try {
		const response = yield call(
			getList,
			"/masters/products/" + proId.payload.id
		);
		yield put(
			product_row_successfull({
				response: {
					...response,
					department_id: response.department
						? response.department.id
						: 0,
					departmentLabel: response.department
						? response.department.name
						: 0,
					category_id: response.category ? response.category.id : 0,
					categoryLabel: response.category
						? response.category.name
						: 0,
					section_id: response.section ? response.section.id : 0,
					sectionLabel: response.section ? response.section.name : 0,
					tax_id: response.tax ? response.tax.id : 0,
					taxLabel: response.tax ? response.tax.name : 0,
					baseunit_id: response.baseunit ? response.baseunit.id : 0,
					baseunitLabel: response.baseunit
						? response.baseunit.name
						: 0,
					group_id: response.group ? response.group.id : 0,
					vendors: response.vendors.map((item, index) => ({
						label: item.name,
						value: item.id,
					})),
				},
			})
		);
	} catch (error) {
		// swal(error[0], {
		//   icon: "error",
		//   timer: 1500,
		// });
		yield put(apiError(error));
	}
}
function* AddProduct({ payload: { product, image, proId, history, model } }) {
	delete product.image;

	try {
		if (proId === 0) {
			const response = yield call(postAdd, "/masters/products/", product);

			if (response.status === 201) {
				product.vendors = [];

				if (image.name) {
					const response2 = yield call(
						putImg,
						"/masters/products/" + response.data.id,
						{
							file: image,
							name: "image",
						}
					);
					if (response2.status === 200) {
						swal("Your Product Added Successfully.!", {
							icon: "success",
							timer: 1500,
						});
						if (model === false) {
							history.push("/Products");
						} else {
							yield put(ProductActivateuccessful(response2.data));
							yield put(cProducthideRightSidebar());
						}
					} else {
						swal(
							"Sorry! Unable to add Product Image. Please Try Again!",
							{
								icon: "error",
								timer: 1500,
							}
						);
						if (model === false) {
							history.push("/Products");
						} else {
							yield put(ProductActivateuccessful(response2.data));
							yield put(cProducthideRightSidebar());
						}
					}
				} else {
					swal("Your Product Added Successfully.!", {
						icon: "success",
						timer: 1500,
					});
					if (model === false) {
						history.push("/Products");
					} else {
						yield put(ProductActivateuccessful(response.data));
						yield put(cProducthideRightSidebar());
					}
				}
			} else {
				swal("Sorry! Unable to add Product. Please Try Again!", {
					icon: "error",
					timer: 1500,
				});
			}
			yield put(productAddSuccessful(null));
		} else {
			const response = yield call(
				postEdit,
				"/masters/products/" + proId,
				product
			);

			if (response.status === 200) {
				if (image.name) {
					const response2 = yield call(
						putImg,
						"/masters/products/" + response.data.id,
						{
							file: image,
							name: "image",
						}
					);
					if (response2.status === 200) {
						swal("Your Product Added Successfully.!", {
							icon: "success",
							timer: 1500,
						});
						history.push("/Products");
					} else {
						swal(
							"Sorry! Unable to add Product Image. Please Try Again!",
							{
								icon: "error",
								timer: 1500,
							}
						);
						history.push("/Products");
					}
				} else {
					swal("Your Product Added Successfully", {
						icon: "success",
						timer: 1500,
					});
					history.push("/Products");
				}
			} else {
				swal("Sorry! Unable to edit Product. Please Try Again!", {
					icon: "error",
					timer: 1500,
				});
			}
			yield put(productAddSuccessful(null));
		}
	} catch (errors) {
		// swal("Sorry! Unable to add Product. Please Try Again!", {
		//   icon: "error",
		//   timer: 1500,
		// });
		yield put(apiError(errors));
	}
}
function* DeleteProduct(proId) {
	try {
		const response = yield call(
			postDelete,
			"/masters/products/" + proId.payload.proId
		);
		if (response.status === 204) {
			swal("Poof! Your Product has been deleted!", {
				icon: "success",
			});
			yield put(getProducts());
		} else {
			swal("Sorry! Your Product has been not deleted!", {
				icon: "error",
			});
		}
	} catch (error) {
		swal(error, {
			icon: "error",
		});

		//yield put(apiError(error));
	}
}

//_______________END____________//

export function* watchgetProducts() {
	yield takeEvery(PRODUCTS, getProduct);
}

export function* watchgetProductGroups() {
	yield takeEvery(PRODUCT_GROUPS, getProductGroups);
}
export function* watchProductAdd() {
	yield takeEvery(PRODUCT_ADD, AddProduct);
}

export function* watchProductDelete() {
	yield takeEvery(PRODUCT_DELETE, DeleteProduct);
}

export function* watchProductRowData() {
	yield takeEvery(GET_PRODUCT_ROW_DATA, GetProductRowData);
}

function* ProductSaga() {
	yield all([
		fork(watchgetProducts),
		fork(watchgetProductGroups),
		fork(watchProductAdd),
		fork(watchProductDelete),
		fork(watchProductRowData),
	]);
}

export default ProductSaga;
